import { render, staticRenderFns } from "./Assigned.vue?vue&type=template&id=6ee97eb9&scoped=true"
import script from "./Assigned.vue?vue&type=script&lang=js"
export * from "./Assigned.vue?vue&type=script&lang=js"
import style0 from "./Assigned.vue?vue&type=style&index=0&id=6ee97eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee97eb9",
  null
  
)

export default component.exports